export class EmailReceipient {
    public readonly email: string;
    public readonly fullName: string | null;

    constructor(data: any) {
        this.email = data.email;
        this.fullName = data.fullName || null;
    }
}
